export const HEADER_HEIGHT = 64;
export const FOOTER_HEIGHT = 40;
export const ZONE_SIDEBAR_WIDTH = 480;
/** Sur mobile, part de la hauteur de l'éditeur qu'occupent d'abord les panneaux, ouverts depuis le bas. */
export const SHEET_DEFAULT_HEIGHT = 0.55;
export const DEFAULT_ORIGIN_CENTER: [number, number] = [210140.5, 5869801.3]; // FRANCE
export const DEFAULT_TEXT_FIXED_SIZE_PX = 16;
export const SLIDER_MAX_TEXT_FIXED_SIZE_PX = 100;
export const MAX_TEXT_FIXED_SIZE_PX = 200;
export const MIN_IMAGE_SCREEN_PX = 30;
export const SHOW_SHAPE_MEASURES = true;
/** Au-delà, une sélection multiple (formes, ou bâtiments de la baguette) est refusée. */
export const MAX_SELECTION_SHAPES = 2000;
export const SHOW_PLAN_IMPORT = true;
export const SHOW_MARKER_TOOL = true;
export const SHOW_DECOR = true;
